export const coupons = {
  webHeading: 'You have unlocked personalised coupons',
  appHeading: 'Your coupons',
  webSubHeading: 'Don’t let your coupons expire. Save them on the ACKO app for your next purchase.',
  appSubHeading: 'Explore your coupons and redeem them to get the best deals on your ACKO purchases',
  mwebButtonText: 'Redeem coupons on the app',
  desktopButtonText: 'Redeem coupons on the app',
  backgroundImage: 'https://acko-cms.ackoassets.com/Subtract_1810cba1ad.png',
  coupons: [
    {
      meta: {
        product_image: 'https://acko-cms.ackoassets.com/Health_Insurance_36c22c79b9.png',
        product_name: 'Health Insurance',
        app_link: 'https://www.acko.com/gi/p/health/segmentV2',
        tags: ['health'],
      },
      title: 'Flat 10% off on the app',
      coupon_code: 'ACKO10HEALTH',
      description: 'Get 10% off on your health insurance premium',
    },
  ],
}

export const challanAppRedirectDesktop = {
  modalData: {
    name: 'challan_app_redirect_modal',
    heading: 'Your challan info is now\navailable on the ACKO app',
    subHeading: 'Get access to exclusive app features',
    cards: [
      {
        logoUrl: 'https://acko-cms.ackoassets.com/wallet_2_f3d69a8d74.webp',
        text: 'Pay challans in one tap',
      },
      {
        logoUrl: 'https://acko-cms.ackoassets.com/Verify_2_cc47c74ecf.webp',
        text: 'Get rewards for driving safe',
      },
      {
        logoUrl: 'https://acko-cms.ackoassets.com/refresh_2_2_560a8db8c5.webp',
        text: 'View all past challans ',
      },
    ],
    carImageSrc: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/modal_car_image_f4f780073d.webp',
    qrHeading: 'Download the app',
    qrSubHeading: 'For iOS and Android',
    qrImageSrc: 'https://acko-cms.ackoassets.com/Ackodrive_Service_center_QR_code_68a8be7619.svg',
    hasVideo: false,
    mediaSrc: 'https://acko-cms.ackoassets.com/Challans_detail_page_5b7586f805.webp',
    bgBlurImageUrl: 'https://acko-cms.ackoassets.com/challan_final_screen_background_5edd7823a3.webp',
    bgHandImageUrl: 'https://acko-cms.ackoassets.com/Ackodrive_modal_middle_layer_image_102d7d6dd9.webp',
  },
}

export const teslaBannerMock = {
  subHeading: 'The future of driving, insured',
  buttonText: 'Know more',
  buttonLink: '/gi/tesla/',
  trackEventType: 'tesla',
}

export const thalaBannerMock = {
  heading: 'MS Dhoni joins team ACKO as an investor',
  subHeading: 'A game-changing partnership for insurance',
  buttonText: 'Know more',
  buttonLink: '/dhoni-press-release',
  trackEventType: 'dhoni_press_release',
}

export const thalaMaddyMock = {
  heading: 'Big savings on car insurance. \nCashless claims everywhere. ',
  subHeading: '',
  buttonText: 'Insure now',
  buttonLink: '/gi/car',
  trackEventType: 'dhoni_madhavan_animated_video',
}

export const desktopThalaMaddyThumbnailUrl = 'https://acko-cms.ackoassets.com/Banner_video_d4e54ad3c7.webp'
export const mobileThalaMaddyThumbnailUrl = 'https://acko-cms.ackoassets.com/D_and_M_mobile_17be3e107f.webp'
export const desktopThalaMaddyVideoUrl = 'https://acko-cms.ackoassets.com/Dhoni_desktop_8321e6ebd6.webm'
export const mobileThalaMaddyVideoUrl = 'https://acko-cms.ackoassets.com/Dhoni_mobile_90de9ac4b7.webm'
export const ackoDhoniLogoAnimation = 'https://acko-cms.ackoassets.com/Acko_dhoni_logo_699abfd82f.mp4'

export const carDropMock = {
  heading: 'A mystery car awaits! Enter to win.',
  subHeading: 'Only for ACKO car policyholders',
  buttonText: 'Join now',
  buttonLink: 'https://ackodrive.com/car-drop/?utm_source=web_gi&utm_medium=banner&utm_campaign=web_gi_banner',
  trackEventType: 'ad_car_drop',
}

export const desktopCarDropThumbnailUrl = 'https://acko-cms.ackoassets.com/Desktop_Banner_Thumbnail_Car_Drop_72a2e2a824.webp'
export const mobileCarDropThumbnailUrl = 'https://acko-cms.ackoassets.com/Mobile_Thumbnail_Cardrop_721e0b0790.webp'
export const desktopCarDropVideoUrl = 'https://acko-cms.ackoassets.com/Desktop_Banner_Car_Drop_98294ecc29.webm'
export const mobileCarDropVideoUrl = 'https://acko-cms.ackoassets.com/Mobile_Cardrop_0d8ad2e610.webm'
export const carDropLogo = "https://acko-cms.ackoassets.com/Car_drop_logo_9433b442d1.svg"
